<app-modal
	#manageStudyModal
	[size]="'md'"
	[hasCloseButton]="false"
	[hasConfirmButton]="false"
	[title]="'studies.manage_study' | translate"
	[staticModal]="true"
	[preventEscape]="true"
>
	<div *ngIf="successMessage" class="text-center py-4">
		<div class="mb-3">
			<fa-icon icon="check-circle" size="3x" class="text-success"></fa-icon>
		</div>
		<h4 class="text-success">{{ successMessage }}</h4>
		<div class="mt-4">
			<button class="btn btn-primary" (click)="closeSuccess()">{{ 'g.close' | translate }}</button>
		</div>
	</div>

	<div *ngIf="!successMessage">
		<alert *ngIf="formError" [type]="'danger'">
			<div [innerHTML]="formError"></div>
		</alert>

		<div class="form-group row">
			<label class="col-sm-4 col-form-label">{{ 'studies.customer_name' | translate }} *</label>
			<div class="col-sm-8">
				<ng-select
					[items]="customers"
					bindLabel="customer_name"
					bindValue="id"
					[clearable]="false"
					name="customer_id"
					[(ngModel)]="selectedCustomerId"
					(ngModelChange)="onCustomerChange($event)"
					placeholder="{{ 'customer.select_customer' | translate }}"
				></ng-select>
			</div>
		</div>

		<div class="form-group row">
			<label class="col-sm-4 col-form-label">{{ 'studies.site_name' | translate }} *</label>
			<div class="col-sm-8">
				<ng-select
					[items]="sites"
					bindLabel="name"
					bindValue="id"
					[clearable]="false"
					name="site_id"
					[(ngModel)]="selectedSiteId"
					[disabled]="!selectedCustomerId"
					placeholder="{{ 'site.select_site' | translate }}"
				></ng-select>
			</div>
		</div>

		<div class="form-group row mt-4">
			<div class="col-sm-12 d-flex justify-content-between">
				<button class="btn btn-light" (click)="cancel()">{{ 'g.cancel' | translate }}</button>
				<button class="btn btn-primary" (click)="submit()">{{ 'g.save' | translate }}</button>
			</div>
		</div>
	</div>
</app-modal>